export default {
    customerServiceInfo: {
        contacts:
        [
            {
                name: "",
                title: "",
                email: "",
                phoneNumber: "",
                imageURL: ""
            }
        ]
    },
    isFetching: false,
    hasError: false
};